import { Base } from '@studiometa/js-toolkit';
import GalleryGrid from '../molecules/GalleryGrid.js';

/**
 * Toast component
 */
export default class Gallery extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Gallery',
    refs: ['btn', 'container', 'json'],
    components: {
      GalleryGrid,
    },
  };

  /**
   * Click on see more
   * @returns {void}
   */
  onBtnClick() {
    this.fetchGallery();
  }

  /**
   * Open Gallery
   * @returns {void}
   */
  fetchGallery() {
    if (this.$children.GalleryGrid.length > 0) {
      this.$children.GalleryGrid[0].openGallery();
      return;
    }

    let jsonData = JSON.parse(this.$refs.json.textContent);
    jsonData = JSON.stringify(jsonData);

    fetch('/wp/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `action=render_template&template=zoomed-gallery&security=custom_nonce&data=${encodeURIComponent(jsonData)}`,
    })
      .then((response) => response.json())
      .then((response) => {
        this.$refs.container.innerHTML = response.data;
        this.$parent.$update();
        this.$update();

        setTimeout(() => {
          this.$children.GalleryGrid[0].openGallery();
        }, 100);
      });
  }
}
